import Asset from '../../asset';
import GenericModel from '../../generic-model';
import { ConditionalPrice } from '../conditional-price';
import { SignTitleAdjustmentAsset } from './sign-title-adjustment-asset';

export class SignTitleAdjustment extends GenericModel {
  archived: boolean;
  title: string;
  examples: SignTitleAdjustmentAsset[];
  width: number;
  height: number;
  inStock: boolean;
  standard: boolean;
  textColor: string;
  foundationColor: string;
  immo: boolean;
  immoInfo: string;
  graphical: boolean;
  graphicalInfo: string;
  atelier: boolean;
  atelierInfo: string;
  installer: boolean;
  installerInfo: string;
  charge: ConditionalPrice;
  graphicsComplete: boolean;
  adminComplete: boolean;

  offlineExamples: Asset[];
}
